// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp, { getServerSideProps as getSSP } from 'tenants/_template/desktop/sellers/[sellerId]'

  

  export const getServerSideProps = getSSP;
  export default PageOrApp;